<template>
  <div>
    <div class="container-fluid pt-0 row mx-0 bg-primary">
      <article
        class="
          container-fluid
          card
          col-sm-12 col-md-12 col-lg-10 col-xl-10
          mycard-scale
          my-4
        "
      >
        <page-breadcrumb :items="page.crumbs" />
        <h1 class="h3 my-3">{{ page.h1 }}</h1>
        <p v-for="(paragraph, index) in page.paragraphs" :key="index" class="p2em">
          {{ paragraph }}
        </p>
        <capacity-table v-if="page.showCapacity" />
        <p v-if="page.serviceName" class="p2em">
          网络货运经营的监管背景可查看
          <a
            class="link-success"
            href="https://www.mot.gov.cn/"
            rel="noopener noreferrer"
            target="_blank"
            >交通运输部</a
          >
          公开信息。桂运宝于2021年通过广西交通运输厅网络货运线上服务能力认定。
        </p>
        <h2 class="h5 mt-4">相关页面</h2>
        <ul>
          <li v-for="link in relatedLinks" :key="link.to">
            <router-link :to="link.to">{{ link.text }}</router-link>
          </li>
          <li><router-link to="/about">了解广西桂运宝科技有限公司</router-link></li>
          <li><router-link to="/faq">查看网络货运常见问题</router-link></li>
          <li><router-link to="/truckage">查询专线及运费</router-link></li>
        </ul>
      </article>
    </div>
  </div>
</template>

<script>
import { PAGES } from "@/seo/site";
import CapacityTable from "@/components/CapacityTable.vue";

/**
 * 业务方案总览与三个场景页共用模板，文案来自站点事实源。
 */
export default {
  name: "SolutionView",
  components: { CapacityTable },
  computed: {
    page: function () {
      return PAGES[this.$route.meta.pageKey] || PAGES.solutions;
    },
    relatedLinks: function () {
      return this.page.links || [];
    },
  },
};
</script>
